<script setup lang="ts">
import CiModalFooter from '@/components/CiModal/CiModalFooter.vue';

/********************
 * PROPS & EMITS     *
 ********************/
export interface CiModalMailProps {
  buttons?: any;
  headline?: string;
  successMessage?: string | null;
}
const props = withDefaults(defineProps<CiModalMailProps>(), {
  headline: '',
  successMessage: null,
  buttons: () => [],
});

const emit = defineEmits<{
  close: [];
}>();

/********************
 * COMPOSITIONS      *
 ********************/
const { $gettext } = useGettext();

const message = computed(() => {
  return props.successMessage
    ? props.successMessage
    : $gettext('Thank you. Your operation has been completed successfully.');
});
</script>

<template>
  <div class="rounded bg-white shadow-2xl">
    <div class="container-fluid p-4">
      <div class="flex justify-center py-6">
        <img
          src="~/assets/svg/icon-mail.svg"
          alt=""
          class="h-auto max-w-[200px]"
        />
      </div>
      <h5 v-if="props.headline" class="mt-6 text-center">
        {{ props.headline }}
      </h5>
      <p class="text-center">
        {{ message }}
      </p>
    </div>
    <CiModalFooter
      v-if="props.buttons?.length"
      class="flex justify-center p-4"
    >
      <div
        v-for="(button, index) in props.buttons"
        :key="`${index}-${button.label}`"
      >
        <CiButton
          v-if="button.to"
          tag="NuxtLink"
          :variant="button.variant"
          :class="button.classes"
          :href="button.to"
          @click="emit('close')"
        >
          {{ button.label }}
        </CiButton>
        <CiButton
          v-if="button.onClick"
          tag="button"
          :variant="button.variant"
          :class="button.classes"
          @click="button.onClick"
        >
          {{ button.label }}
        </CiButton>
      </div>
    </CiModalFooter>
  </div>
</template>
